import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { connect } from 'react-redux';
import { generatePath, Link } from 'react-router-dom';
import { isError, isSuccess, ResourcesItem } from 'redux-and-the-rest';

import { ApplicationState } from '../../redux/types';
import Header from '../shared/Header';
import TextInput from '../shared/TextInput';
import { createPasswordReset, getPasswordReset, clearPasswordReset } from '../../redux/reducers/passwordResetReducer';
import { PasswordResetModel } from '../../models/passwordResetModel';
import { Routes } from '../../routes';

interface ForgotPasswordFields {
  email: string
}

interface Props {
  onSubmit(email: string): void
  passwordReset: ResourcesItem<PasswordResetModel>,
  onClearPasswordReset(): void
}

const ForgotPasswordPanel = ({ onSubmit, passwordReset, onClearPasswordReset }: Props) => {
  const {
    register, handleSubmit, formState: { errors }, setError, reset: resetForm,
  } = useForm<ForgotPasswordFields>();

  const submit = handleSubmit(({ email }) => {
    onSubmit(email);
    resetForm();
  });

  useEffect(() => {
    // The error returned is only ever a missing email field
    if (isError(passwordReset)) {
      setError('email', { message: 'Your email address is required' });
    }
  }, [passwordReset.status]);

  if (isSuccess(passwordReset)) {
    return (
      <div className="panel box">
        <div className="form">
          <div className="form-section">
            <Header variant="h2" title="Forgot Password" />

            <p className="message">
              We've sent an email to the address you provided. Please click on the link in that email
              to reset your account
            </p>

          </div>

          <div className="form-section form-actions">
            <Link className="button primary" to={generatePath(Routes.Session.New)}>
              Back
            </Link>

            <button className="button primary" type="submit" onClick={onClearPasswordReset}>
              Resend Email
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="panel box">
      <form className="form" onSubmit={submit}>
        <div className="form-section">
          <Header variant="h2" title="Forgot Password" />

          <div className="form-group">
            <TextInput
              require
              label="Email address"
              useFormRegisterReturn={register('email', { required: 'Your email adress is required' })}
              error={errors.email?.message}
            />
          </div>
        </div>

        <div className="form-section form-actions">
          <Link className="button primary" to={generatePath(Routes.Session.New)}>
            Back
          </Link>

          <button className="button primary" type="submit">
            Send Email
          </button>
        </div>
      </form>
    </div>
  );
};

const mapReduxStateToProps = (({ passwordResets }: ApplicationState) => ({
  onSubmit: (email: string) => {
    createPasswordReset({ email, type: 'passwordReset' });
  },
  passwordReset: getPasswordReset(passwordResets),
  onClearPasswordReset: clearPasswordReset,
}));

export default connect(mapReduxStateToProps)(ForgotPasswordPanel);
